import type { IconData } from '@stacksjs/iconify-core'

export const basicUiQuestion: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M8 10a5 5 0 1 0-5-5v1h4v4zm0 6a2.5 2.5 0 1 0 0-5a2.5 2.5 0 0 0 0 5\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicUiQuestion
